// extracted by mini-css-extract-plugin
export default {"none":"kKUi09Qe7F"};